import script from "./ConsumerView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerView.vue?vue&type=style&index=0&id=099afc02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099afc02"]])

export default __exports__